import React           from "react";
import PropTypes       from 'prop-types';
import Constants, { getTypeByColor }       from './Constants';
import Flux            from '../../flux/Flux';
import Translations    from '../../utils/Translations';
import Alert, { BUTTON } from "../Alert/Alert";

export default class StatusBarGuestCancelationOffer extends React.Component {

	constructor(props) {
		super(props);
	}


	render() {
        if (!this.props.isVisible) {
            return null;
        }
        const onAcceptCancellationOffer = () => {
			Flux.Guest.acceptCancellationOffer(this.props.guestId, Translations.get('StatusBarGuestCancellationOfferPlatformType'), this.props.offerActivationFail, this.props.offerActivationSuccess);
		};
        return <Alert
                type={getTypeByColor(this.props.barColor)}
                text={this.props.msgOutro}
                buttons={[{text: Translations.get('StatusBarGuestCancellationOfferAcceptButton'), onClick: onAcceptCancellationOffer, type: BUTTON.PRIMARY}]}
        />;
	}
}

StatusBarGuestCancelationOffer.propTypes = {
	barColor:               PropTypes.string.isRequired,
	msgOutro:               PropTypes.string.isRequired,
	isVisible:              PropTypes.bool.isRequired,
	guestId:                PropTypes.number.isRequired,
	offerActivationFail:    PropTypes.func,
	offerActivationSuccess: PropTypes.func,
};

StatusBarGuestCancelationOffer.defaultProps = {
	barColor: Constants.BARCOLOR_WHITE,
};
